module.exports = __webpack_public_path__ + "58b950131d6e75ba69159cee34028768.png";